/*scroll header*/
$(window).scroll(function() {
  if ($(document).scrollTop() > 700) {
      $('.header_wrapper').addClass('scrolled');
  }
  else{
    $('.header_wrapper').removeClass('scrolled');
  }
});

/*Detect Direction*/
var lastScrollTop = 0;
$(window).scroll(function(event){
   var st = $(this).scrollTop();
   if (st > lastScrollTop){
       // downscroll code
       $('.header_wrapper').addClass('down');
   } else {
      // upscroll code
      $('.header_wrapper').removeClass('down');
   }
   lastScrollTop = st;
});


/*Language Switcher*/
$(".language.is-active").on('click', function() {
    return false;
})





/*Open Menu*/
$(".menu_button").on('click', function() {
      if($(this).hasClass('is-active')){
          $("body").css('overflow-y','scroll');
          $(this).removeClass('is-active');
          $('.menu_button').removeClass('is-active');
          $('.headermenu').removeClass('is-active');
          $('.header_wrapper').removeClass('is-active');
        }
        else{
          $(this).addClass('is-active');
          $('.menu_button').addClass('is-active');
          jQuery("body").css('overflow-y','hidden');
          $('.headermenu').addClass('is-active');
          $('.header_wrapper').addClass('is-active');
      }
});




/*Gallery*/
          import Swiper, { Navigation, Pagination } from 'swiper';

          const gallery_room_swipe = new Swiper(".gallery_room_swipe", {
            loop: true,
            spaceBetween: 0,
            grabCursor: true,
            slidesPerView:1,
            speed: 1000,
            centeredSlides: false
          });

          const gastronomy_home_swipe = new Swiper(".gastronomy_home_swipe", {
            loop: false,
            spaceBetween: 0,
            grabCursor: true,
            slidesPerView:1,
            speed: 1000,
            centeredSlides: false
          });

          // const gallery_swi = new Swiper(".gallery_swipe", {
          //   loop: true,
          //   spaceBetween: 20,
          //   grabCursor: true,
          //   slidesPerView:1.5,
          //   speed: 1000,
          //   centeredSlides: false,
          //   breakpoints: {
          //    // when window width is >= 0px
          //    0: {
          //      slidesPerView:1,
          //    },
          //    300: {
          //      slidesPerView:1,
          //    },
          //    // when window width is >= 550px
          //    550: {
          //      slidesPerView:1,
          //    },
          //    // when window width is >= 1024px
          //    1024: {
          //      slidesPerView:1.5,
          //    },
          //    // when window width is >= 1200px
          //    1200: {
          //      slidesPerView:1.5,
          //    }
          //  }
          // });


          const room_home_swipe = new Swiper(".room_home_swipe", {
            loop: true,
            spaceBetween:30,
            grabCursor: true,
            slidesPerView:1.5,
            speed:500,
            breakpoints: {
             // when window width is >= 0px
             0: {
               slidesPerView:1,
             },
             300: {
               slidesPerView:1,
             },
             // when window width is >= 768px
             768: {
               slidesPerView:1,
             },
             // when window width is >= 1024px
             1024: {
               slidesPerView:1.3,
             },
             // when window width is >= 1200px
             1200: {
               slidesPerView:1.5,
             }
           }
          });

          // Location Page Gallery
const progressTime = document.querySelector(".button-container");
const gallery_swi_ = new Swiper(".gallery_swipe", {
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false
  },
  spaceBetween: 20,
  grabCursor: true,
  slidesPerView: 1,
  speed: 1000,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
    }
  },
  // on: {
  //   autoplayTimeLeft(s, time, progress) {
  //     progressTime.style.setProperty("--_progress", 1 - progress * 100 + "%");
  //   }
  // }
});
// Scroller EXPLORE
const scroller = document.querySelector(".fixed_explore");
window.addEventListener("load", function () {
  scroller.style.setProperty("--y-scroll-page", "0%");
  window.addEventListener("scroll", function () {
    let scrollPosition = window.scrollY;
    let totalHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    let scrollPercentage = (scrollPosition / totalHeight) * 100;
    let roundedPercentage = Math.floor(scrollPercentage);
    scroller.style.setProperty("--y-scroll-page", `${roundedPercentage}%`);
  });
});
// Discover more swiper
const discover_swipe = new Swiper(".discover-swiper", {
  loop: true,
  spaceBetween: 30,
  grabCursor: true,
  slidesPerView: 1.5,
  centeredSlides: false,
  breakpoints: {
    // when window width is >= 0px
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    300: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 1,
      spaceBetween: 15,
    },
    // when window width is >= 1024px
    1024: {
      slidesPerView: 1.5,
      spaceBetween: 20,
    },
    // when window width is >= 1200px
    1200: {
      slidesPerView: 1.5,
      spaceBetween: 30,
    },
  },
});
